function initProductTabs(root = document) {
  root.querySelectorAll('.product-tabs').forEach(tabs => {
    if (tabs.dataset.initialized) return;
    tabs.dataset.initialized = 'true';

    const buttons = tabs.querySelectorAll('[data-tab]');
    const contents = tabs.querySelectorAll('[data-section]');

    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        buttons.forEach(b => b.classList.remove('active'));
        contents.forEach(c => c.classList.remove('active'));

        btn.classList.add('active');
        tabs
          .querySelector(`[data-section="${btn.dataset.tab}"]`)
          ?.classList.add('active');
      });
    });

    if (buttons.length) buttons[0].click();
  });
}

/* initial load */
document.addEventListener('DOMContentLoaded', () => {
  initProductTabs(document);
});

/* Horizon / OS 2.0 dynamic updates */
new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    mutation.addedNodes.forEach(node => {
      if (node.nodeType === 1) initProductTabs(node);
    });
  });
}).observe(document.body, {
  childList: true,
  subtree: true
});
